import { VStack, Flex, Icon, Text, Divider, Button, Box } from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';

import { IoArrowForwardCircle, IoCheckmarkCircle, IoCloseCircle } from 'react-icons/io5';
import { Coupon } from '~/types/coupon';

import transformCouponDiscountString from '~/utils/transformCouponDiscountString';

type CouponItemProps = {
  isSelected: boolean;
  isEnable?: boolean;
  onClick?: () => void;
  onNavigate?: () => void;
  coupon: Coupon & { storesName: Array<string> };
};

export default function CouponItem({
  isSelected,
  isEnable = true,
  coupon,
  onClick,
  onNavigate,
}: CouponItemProps) {
  return (
    <Flex
      borderWidth="2px"
      borderColor="gray.400"
      borderRadius="5px"
      position="relative"
      opacity={isEnable ? 1 : 0.5}
    >
      <VStack flex="1" align="flex-start" spacing={1} p={2} overflow="hidden">
        <Text fontSize="sm" fontWeight="bold">
          {coupon.name}
        </Text>
        <Text fontSize="xs" color="gray.500">
          使用期限：{format(parseISO(coupon.endDate), 'yyyy/MM/dd')}
        </Text>
        <Text fontSize="xs" color="gray.500" isTruncated maxW="18rem">
          適用店家:{coupon.storesName.join('、')}
        </Text>
        <Button
          size="xs"
          bgColor="gray.200"
          fontWeight="normal"
          color="gray.500"
          letterSpacing={1}
          _hover={{}}
          onClick={onNavigate}
        >
          優惠券詳情
        </Button>
        <Divider />
        <Text fontSize="xs" fontWeight="bold" color="danger.600">
          {transformCouponDiscountString(coupon.type, coupon.condition)}
        </Text>
      </VStack>
      <VStack
        minW="4rem"
        p={2}
        justify="center"
        borderLeftWidth="2px"
        borderStyle="dashed"
        borderColor="gray.400"
        position="relative"
        bgColor={isSelected ? 'dark' : 'gray.100'}
        onClick={onClick}
      >
        {isSelected ? (
          <>
            <Icon as={IoCloseCircle} boxSize="2rem" color="white" />
            <Text color="white">取消</Text>
          </>
        ) : (
          <>
            <Icon as={IoCheckmarkCircle} boxSize="2rem" color="gray.500" />
            <Text color="gray.500">選擇</Text>
          </>
        )}

        {/** top concavity mask */}
        <Box
          w="1rem"
          h="1rem"
          bgColor="white"
          borderWidth="2px"
          borderRadius="full"
          borderColor="gray.400"
          borderTopColor="transparent"
          borderLeftColor="transparent"
          transform="rotate(45deg)"
          position="absolute"
          top="-18px"
          left="-9px"
        />
        {/** bottom concavity mask */}
        <Box
          w="1rem"
          h="1rem"
          bgColor="white"
          borderWidth="2px"
          borderRadius="full"
          borderColor="gray.400"
          borderBottomColor="transparent"
          borderRightColor="transparent"
          transform="rotate(45deg)"
          position="absolute"
          bottom="-9px"
          left="-9px"
        />
      </VStack>
    </Flex>
  );
}
